import SpotifyFollowUserTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/spotify/triggers/followUser/InstructionsComponent';
import type {TriggerIntegration} from '@cohort/merchants/apps';
import useSocialStepCompletionColumns from '@cohort/merchants/apps/common/triggers/useSocialStepCompletionColumns';
import SpotifyFollowUserTriggerActionCtaComponentPreview from '@cohort/merchants/apps/spotify/triggers/followUser/ActionCtaComponentPreview';
import SpotifyFollowUserTriggerIntegrationConfigComponent from '@cohort/merchants/apps/spotify/triggers/followUser/ConfigComponent';
import SpotifyFollowUserTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/spotify/triggers/followUser/StepCompletionTitleComponent';
import type {SpotifyFollowUserTriggerStruct} from '@cohort/shared/apps/spotify/triggers/followUser';
import {SpotifyFollowUserTriggerSpec} from '@cohort/shared/apps/spotify/triggers/followUser';

export const SpotifyFollowUserTriggerIntegration: TriggerIntegration<SpotifyFollowUserTriggerStruct> =
  {
    spec: SpotifyFollowUserTriggerSpec,
    configComponent: SpotifyFollowUserTriggerIntegrationConfigComponent,
    stepCompletionTitleComponent: SpotifyFollowUserTriggerIntegrationStepCompletionTitleComponent,
    useStepCompletionColumns: context =>
      useSocialStepCompletionColumns<SpotifyFollowUserTriggerStruct>({
        ...context,
        userNameKey: 'userName',
      }),
    getTitle: t => t('triggerIntegrations.follow-user.title', {ns: 'app-spotify'}),
    preview: {
      InstructionsComponent: SpotifyFollowUserTriggerIntegrationInstructionsComponent,
      CtaComponent: SpotifyFollowUserTriggerActionCtaComponentPreview,
    },
  };
